import Clarity from '@microsoft/clarity'
// helpers
import { isString } from './string'

const identifyClarity = (category?: string) => {
  // @ts-ignore
  const deviceId = window.$amplitudeDeviceId

  if (deviceId) {
    Clarity.identify(deviceId)
    Clarity.setTag('device_id', deviceId)
    Clarity.setTag('amplitude_url', `https://app.amplitude.com/analytics/skelar/project/472284/search/${deviceId}`)
    Clarity.setTag('category', category || '')
  } else {
    console.warn('identifyClarity processing...')
    setTimeout(() => identifyClarity(category), 1000)
  }
}

export const initClarity = (selector: string, category?: string) => {
  const el = document.querySelector(selector)
  if (el) {
    const enabled = el.getAttribute('data-cl-enabled')
    const isEnabled = (enabled === 'enabled')
    if (!isEnabled) {
      console.log('%Clarity is disabled.')
    } else {
      const projectId = el.getAttribute('data-cl-id')

      const validProjectId = isString(projectId)
      if (!validProjectId) {
        console.log('%cError: Invalid Clarity Project ID.', 'color: #DB4437;')
      } else {
        Clarity.init(projectId)
        identifyClarity(category)
      }
    }
  }
}
